/**
 * The fields the membership fields has
 */
export const fields = {
    forename                  : '',
    middle_name               : '',
    surname                   : '',
    organisation              : '',

    how_did_you_hear_about_us       : '',
    how_did_you_hear_about_us_other : '',
    
    contact                   : {
        email                       : '',
        email_confirmation          : '',
        contact_number              : '',
        contact_number_confirmation : '', 
        mobile_number               : '',
        address_line_1              : '',
        address_line_2              : '',
        city                        : '',
        postcode                    : '',
        county                      : '',
        country                     : ''
    },

    ticket: {
        ticket   : {},
        quantity : 1,
        people   : []
    },

    workshops: {},

    options: [],

    confirms_details  : false,
    marketing_consent : false
}